import { render, staticRenderFns } from "./ConfigurationItemsDiscountListCard.vue?vue&type=template&id=4d5c833d&"
import script from "./ConfigurationItemsDiscountListCard.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationItemsDiscountListCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports